import { format } from 'date-fns';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

import { ArrowLink } from '../Common/Links';
import * as styles from './NewsCard.module.css';

const NewsCard = ({ title, url, logo, ctaLabel, logoFallback, isFullStory, publishDate = '' }) => {
  const splitDate = publishDate.split('T');
  const date = format(new Date(splitDate[0]), 'MMMM yyyy');
  return (
    <div className={[styles.card, isFullStory ? styles.fs : styles.nfs].join(' ')}>
      <div className={styles.top}>
        {!!logo && <img className={styles.logo} src={get(logo, 'file.url')} alt={get(logo, 'title')} />}
        {!logo && <span className={styles.fallback}>{logoFallback}</span>}
        <span className={styles.date}>{date}</span>
      </div>
      <div>
        <h3>{title}</h3>
      </div>
      <ArrowLink label={ctaLabel} url={url} isExternal />
    </div>
  );
};

NewsCard.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  ctaLabel: PropTypes.string.isRequired,
  logo: PropTypes.object,
  logoFallback: PropTypes.string,
  isFullStory: PropTypes.bool,
};

export default NewsCard;
